import React, { useEffect } from 'react'
import Wrapper from '../../UI/Wrapper'
import Sidebar from '../../components/Common/Sidebar'
import Main from '../../components/FormScreen/Main'
import Left from '../../components/Coach/Welcome/Left'
import Calendar from '../../components/Coach/Welcome/Calendar'
import { useGetCurrentUserQuery ,useGetTimezonesQuery,useUpdateCoachTimezoneMutation} from '../../services/authApi'
import ReactGA from "react-ga"
const tzAliases = {
  'Asia/Calcutta': 'Asia/Kolkata',
   'Asia/Bombay': 'Asia/Kolkata',
   'Asia/Colombo': 'Asia/Colombo',
  'US/Eastern': 'America/New_York',
  'US/Central': 'America/Chicago',
  'US/Mountain': 'America/Denver',
  'US/Pacific': 'America/Los_Angeles',
  // Add other known aliases here
   // United States
  'US/Eastern': 'America/New_York',
  'US/Central': 'America/Chicago',
  'US/Mountain': 'America/Denver',
  'US/Pacific': 'America/Los_Angeles',
  'US/Alaska': 'America/Anchorage',
  'US/Hawaii': 'Pacific/Honolulu',
  'Etc/UTC': 'UTC',
  'Etc/GMT': 'GMT',
  'Etc/GMT+0': 'GMT',
  'Etc/GMT-0': 'GMT',
  // Canada
  'Canada/Eastern': 'America/Toronto',
  'Canada/Central': 'America/Winnipeg',
  'Canada/Mountain': 'America/Edmonton',
  'Canada/Pacific': 'America/Vancouver',

  // Australia
  'Australia/Sydney': 'Australia/Sydney',
  'Australia/Melbourne': 'Australia/Melbourne',
  'Australia/Brisbane': 'Australia/Brisbane',
  'Australia/Adelaide': 'Australia/Adelaide',
  'Australia/Perth': 'Australia/Perth',
  'Australia/Hobart': 'Australia/Hobart',
  'Australia/Lord_Howe': 'Australia/Lord_Howe',

  // Europe
  'Europe/Belfast': 'Europe/London',
  'Europe/Tel_Aviv': 'Asia/Jerusalem',
  'Europe/Kyiv': 'Europe/Kiev',
}
const normalizeTz = tz => tzAliases[tz] || tz
const WelcomeCoach = () => {
  const deviceTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const [updateProfile] = useUpdateCoachTimezoneMutation();
  //Google Analytics
  useEffect(() => {
    ReactGA.pageview(window.location.pathname)
  }, [])
const {
        data: userInfo,
        isLoading,
        isError,
        isSuccess,
    } = useGetCurrentUserQuery({})
    const user = userInfo?.data
    //  console.log(user);
      const { data: timezoneData, isLoading: tzLoading } = useGetTimezonesQuery()
      // console.log(timezoneData);
       useEffect(() => {
  if (!deviceTimezone || !timezoneData?.data) return;

  const normalizedDeviceTz = normalizeTz(deviceTimezone);
  const normalizedUserTz = normalizeTz(user?.timezone?.name);

  // Find matching timezone from API data
  const matchedTz = timezoneData.data.find(
    (tz) => tz.name === normalizedDeviceTz
  );

  if (!matchedTz) {
    // console.warn("Device timezone not found in timezoneData:", normalizedDeviceTz);
    return;
  }

  // Case 1: User has no timezone -> set device timezone
  if (!user?.timezone) {
    // console.log("hh");
    
    const formData = new FormData();
    formData.append("timezone_id", matchedTz.id);
formData.append('name', user?.name);
		formData.append('gender', user?.gender);
		formData.append('dob', user?.dob);
    updateProfile(formData)
      .unwrap()
      .then((res) => {
        // console.log("Timezone updated (no user tz):", res);
        localStorage.setItem("device_timezone", normalizedDeviceTz);
      })
      .catch((err) => console.error("Update failed:", err));

    return;
  }

  // Case 2: User has timezone but different from device -> update
  if (normalizedUserTz !== normalizedDeviceTz) {
    // console.log("nbh");
    
    const formData = new FormData();
    formData.append("timezone_id", matchedTz.id);
formData.append('name', user?.name);
		formData.append('gender', user?.gender);
		formData.append('dob', user?.dob);
    updateProfile(formData)
      .unwrap()
      .then((res) => {
        // console.log("Timezone updated (different tz):", res);
        localStorage.setItem("device_timezone", normalizedDeviceTz);
      })
      .catch((err) => console.error("Update failed:", err));
  }
}, [user, deviceTimezone, timezoneData]);
  return (
    <Wrapper>
      <div className="flex">
        <Sidebar notLoggedIn={false} />
        <Main>
          <div className='flex mx-auto space-x-20'>
            <Left />
            <Calendar />
          </div>

        </Main>
      </div>
    </Wrapper>
  )
}

export default WelcomeCoach